import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Grid, Paper, Skeleton, Tab, tabsClasses, Typography } from "@mui/material";
import { config, styles } from "../../style";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { recentStoriesSkeleton } from "./skeleton";
import { Modal } from "../../components/Modal";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { get, post } from "../../api";
import { useAuth } from "../../hooks/useAuth";
import RenderContent from "../../components/RenderContent";
import { Speaker } from "../Speaker";
import { useDispatch, useSelector } from "react-redux";
import { initialize, selectDashboardData } from "./dashboardSlice";

const AgentStoriesJson = {
    isSuccess: true,
    data: [
        {
            title: "Recent Stories",
            recordType: "Story List",
            id: "a3XVC000001Hoz72AC",
            data: [
                {
                    id: "a3eVC000000YSZlYAO",
                    storyId: "a3bVC000000sr0vYAA",
                    authorName: "Gustavo Melendez",
                    authorImage: "https://wsb-crm--uat.sandbox.file.force.com/profilephoto/7293J000000L1cg/F",
                    authorRole: "Contractor",
                    shortDescription:
                        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo",
                    title: "Title for post here consect adipiscing",
                    likesCount: 2,
                },
                {
                    id: "a3eVC000000YSbNYAW",
                    storyId: "a3bVC000000sr49YAA",
                    authorName: "Kevin Keller",
                    authorImage: "https://wsb-crm--uat.sandbox.file.force.com/profilephoto/7293J000000L1cR/F",
                    authorRole: "System Administrator",
                    shortDescription:
                        "Last evening, WSB brought together a diverse gathering of thought leaders, visionaries, and changemakers for a powerful event that celebrated storytelling, leadership, and purpose. Hosted at [Venue/Virtual], the event served as a platform for compelling n",
                    title: "Elevating Voices – A Transformative Evening at WSB",
                    likesCount: 1,
                },
            ],
        },
    ],
};

function AgentStoriesCard({ setAgentStoriesShow }) {
    const dashboardData = useSelector(selectDashboardData);

    const [allList, setAllList] = useState(dashboardData.agentStories || []);
    const [value, setValue] = React.useState(dashboardData.agentStories?.[0]?.id || "");
    const [currentList, setCurrentList] = useState(dashboardData.agentStories?.[0] || {});
    const [data, setData] = useState(dashboardData.agentStories?.[0]?.data || []);
    const [currentStory, setCurrentStory] = useState(dashboardData.agentStories?.[0]?.data?.[0] || {});
    const [loading, setLoading] = useState(false);
    const [contactAllImages, setContactAllImages] = useState({});

    const [openModal, setOpenModal] = useState(false);
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [openSpeakerScreen, setOpenSpeakerScreen] = useState(false);
    const [speakerSearchSelectedTeb, setSpeakerSearchSelectedTeb] = useState("");
    const [selectedSpeaker, setSelectedSpeaker] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        const handleAllSetStates = (data) => {
            setAllList(data);
            setValue(data[0].id);
            setCurrentList(data[0]);
            setData(data[0].data);
            setCurrentStory(data[0].data[0] || {});

            let allImages = {};
            for (let list of data) {
                for (let contact of list.data) {
                    if (contact.authorImage) {
                        allImages[contact.authorImage] = "";
                    }
                }
            }

            if (allImages && Object.keys(allImages).length > 0) {
                let imagePromises = Object.keys(allImages).map((imageURL) => contactImage(imageURL));

                Promise.all(imagePromises).then((urls) => {
                    urls.forEach((url, index) => {
                        allImages[Object.keys(allImages)[index]] = url;
                    });
                    setContactAllImages(allImages);
                });
            }
        };

        if (dashboardData.agentStories) {
            if (dashboardData.agentStories?.length > 0) {
                handleAllSetStates(dashboardData.agentStories);
            } else {
                setAgentStoriesShow(false);
            }
        } else {
            setLoading(true);
            get("dashboard/getAgentStories", { accountId: userDetails.contact.accountId })
                .then((res) => {
                    if (res.isSuccess && res.data) {
                        if (res.data?.length > 0) {
                            handleAllSetStates(res.data);
                            dispatch(
                                initialize({
                                    agentStories: res.data,
                                })
                            );
                        } else {
                            dispatch(
                                initialize({
                                    agentStories: [],
                                })
                            );
                            setAgentStoriesShow(false);
                        }
                    } else {
                        setAgentStoriesShow(false);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Error fetching dashboard data:", error);
                    setLoading(false);
                    setAgentStoriesShow(false);
                });
        }
    }, []);

    const contactImage = async (imageURL) => {
        if (imageURL) {
            let result = await get("opportunity/getUserImage", {
                url: encodeURIComponent(imageURL),
            });

            if (result.isSuccess) {
                return result.data;
            }
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedList = allList.find((cItem) => cItem.id === newValue);
        setCurrentList(selectedList);
        setData(selectedList.data);
        setCurrentStory(selectedList.data[0] || {});
        // let hasImage = selectedList.data.find((contact) => contact.imageURL);
        // if (!hasImage) {
        //     Promise.all(selectedList.data.map((contact) => contactImage(contact.authorImage))).then((urls) => {
        //         let records = selectedList.data.map((contact, index) => ({
        //             ...contact,
        //             imageURL: urls[index],
        //         }));
        //         setData([...records]);
        //         setCurrentStory(records[0]);
        //     });
        // }
    };

    const handleOpenModal = async () => {
        if (!currentStory.body) {
            let story = { ...currentStory };
            story.mentionedSpeakers = [];
            story.body = "";
            get("dashboard/getStoryDetails", {
                contactId: userDetails.contact.id,
                storyId: story.storyId,
            }).then((res) => {
                if (res.isSuccess && res.data) {
                    story.mentionedSpeakers = res.data.speakers || [];
                    story.body = res.data.body;
                    story.activity = res.data.activities?.length > 0 ? res.data.activities[0] : undefined;
                }
                setCurrentStory(story);
                setData(
                    data.map((item) => {
                        if (item.id === story.id) {
                            return story;
                        }
                        return item;
                    })
                );
            });
        }
        setOpenModal(true);
    };
    const handleCloseModal = () => setOpenModal(false);

    const handleNextStory = () => {
        const currentStoryIndex = data.findIndex((cItem) => cItem.id === currentStory.id);
        if (currentStoryIndex === data.length - 1) {
            return;
        }
        setCurrentStory(data[currentStoryIndex + 1]);
    };

    const handleBackStory = () => {
        const currentStoryIndex = data.findIndex((cItem) => cItem.id === currentStory.id);
        if (currentStoryIndex === 0) {
            return;
        }
        setCurrentStory(data[currentStoryIndex - 1]);
    };

    const currentStoryIndex = data.findIndex((cItem) => cItem.id === currentStory?.id);

    const likeClick = () => {
        let story = { ...currentStory };
        post("dashboard/saveStoryLike", {
            contactId: userDetails.contact.id,
            storyId: story.storyId,
            isRemove: false,
        }).then((res) => {
            if (res.isSuccess && res.data) {
                story.activity = res.data;
                setCurrentStory(story);
                setData(
                    data.map((item) => {
                        if (item.id === story.id) {
                            return story;
                        }
                        return item;
                    })
                );
            } else {
                console.error("Error liking story:", res.errorMessage);
            }
        });
    };

    const removeLikeClick = () => {
        let story = { ...currentStory };
        post("dashboard/saveStoryLike", {
            contactId: userDetails.contact.id,
            storyId: story.storyId,
            isRemove: true,
        }).then((res) => {
            if (res.isSuccess && res.data) {
                story.activity = undefined;
                setCurrentStory(story);
                setData(
                    data.map((item) => {
                        if (item.id === story.id) {
                            return story;
                        }
                        return item;
                    })
                );
            } else {
                console.error("Error liking story:", res.errorMessage);
            }
        });
    };

    // if(!allList?.length){

    //     return null

    // }

    return (
        <Paper
            sx={{
                borderRadius: "10px",
                padding: "1rem",
                boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
                height: "100%",
            }}
        >
            <Typography
                component={"h1"}
                sx={{
                    ...styles.paperHeader,
                }}
            >
                From the Front Row
            </Typography>

            <Box marginTop={"0.5rem"}>
                {loading ? (
                    recentStoriesSkeleton
                ) : (
                    <>
                        {allList?.length > 0 ? (
                            <TabContext value={value}>
                                <TabList
                                    variant="scrollable"
                                    // scrollButtons
                                    allowScrollButtonsMobile
                                    onChange={handleChange}
                                    aria-label="Event tabs"
                                    sx={{
                                        [`& .${tabsClasses.scrollButtons}`]: {
                                            "&.Mui-disabled": { opacity: 0.3 },
                                        },
                                        minHeight: "unset",
                                        // maxHeight: "44px",
                                        "&.MuiTabs-root": {
                                            marginLeft: "-0.5rem",
                                            marginRight: "-0.5rem",
                                        },
                                        "& .MuiButtonBase-root.MuiTab-root": {
                                            color: "#A0A0AB",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            textTransform: "initial",
                                            minHeight: "unset",
                                            padding: "10px 0px",
                                            margin: "0 8px",

                                            "&:first-of-type": {
                                                marginLeft: "0px",
                                            },

                                            "&.Mui-selected": {
                                                color: "#444CE7",
                                            },
                                        },

                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "#444CE7",
                                        },

                                        // "& .MuiTabScrollButton-root:first-of-type": {
                                        //     backgroundColor: "lightgray",
                                        //     color: "red",
                                        // },
                                        // "& .MuiTabScrollButton-root:last-of-type": {
                                        //     backgroundColor: "lightblue",
                                        //     color: "blue",
                                        // },
                                    }}
                                >
                                    {allList?.map((cTab, index) => {
                                        return <Tab key={index} label={cTab.title} value={cTab.id} />;
                                    })}
                                </TabList>

                                {currentList?.id && currentStory?.id && (
                                    <TabPanel value={currentList?.id} sx={{ padding: 0, marginTop: "1.5rem" }}>
                                        <>
                                            {currentStory && (
                                                <Card sx={{ border: "unset", boxShadow: "unset", overflow: "unset" }}>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar
                                                                alt={currentStory.authorName}
                                                                src={contactAllImages[currentStory.authorImage]}
                                                                sx={{
                                                                    "& .MuiAvatar-img": {
                                                                        objectFit: "cover",
                                                                        objectPosition: "top center",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        title={currentStory.authorName}
                                                        subheader={currentStory.authorRole}
                                                        sx={{
                                                            padding: 0,
                                                        }}
                                                        titleTypographyProps={{
                                                            sx: {
                                                                color: "#26272B",
                                                                fontSize: "16px",
                                                                fontWeight: 600,
                                                                lineHeight: "20px" /* 125% */,
                                                            },
                                                        }}
                                                        subheaderTypographyProps={{
                                                            sx: {
                                                                color: "#312E81",
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: "20px" /* 166.667% */,
                                                            },
                                                        }}
                                                    />
                                                    <CardContent sx={{ padding: 0, marginTop: "1rem", height: "203px" }}>
                                                        <Typography
                                                            component={"h1"}
                                                            color={"#26272B"}
                                                            fontSize={"16px"}
                                                            sx={{
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                            fontWeight={700}
                                                        >
                                                            {currentStory.title}
                                                        </Typography>
                                                        <Typography
                                                            component={"p"}
                                                            color={"#3F3F46"}
                                                            fontSize={"14px"}
                                                            fontWeight={400}
                                                            marginTop={"0.5rem"}
                                                            sx={{
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 6,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                        >
                                                            {currentStory?.shortDescription}
                                                        </Typography>

                                                        <Button
                                                            sx={{
                                                                color: "#444CE7",
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                lineHeight: "20px" /* 142.857% */,
                                                                textDecorationLine: "underline",
                                                                textDecorationStyle: "solid",
                                                                textDecorationSkipInk: "auto",
                                                                textDecorationThickness: "auto",
                                                                textUnderlineOffset: "auto",
                                                                textUnderlinePosition: "from-font",
                                                                marginTop: "0.5rem",
                                                                cursor: "pointer",
                                                                padding: 0,
                                                            }}
                                                            onClick={handleOpenModal}
                                                        >
                                                            Read Story
                                                        </Button>
                                                    </CardContent>
                                                    <CardActions
                                                        sx={{
                                                            borderTop: "1px solid #E4E4E7",

                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",

                                                            margin: "1rem -1rem -1rem",
                                                            padding: "0 1rem",
                                                        }}
                                                    >
                                                        <Typography
                                                            component={"span"}
                                                            color={"#444CE7"}
                                                            fontSize={"16px"}
                                                            fontWeight={400}
                                                            height={`46px`}
                                                            display={"flex"}
                                                            justifyContent={"center"}
                                                            alignItems={"center"}
                                                        >
                                                            {currentStoryIndex + 1}/{data?.length}
                                                        </Typography>

                                                        <Box>
                                                            {currentStoryIndex > 0 && (
                                                                <Button
                                                                    variant="text"
                                                                    startIcon={<WestIcon />}
                                                                    sx={{
                                                                        fontSize: "16px",
                                                                        fontWeight: 700,

                                                                        "& .MuiSvgIcon-root": {
                                                                            color: "#3538CD",
                                                                        },
                                                                    }}
                                                                    onClick={handleBackStory}
                                                                >
                                                                    Back
                                                                </Button>
                                                            )}
                                                            {currentStoryIndex < data.length - 1 && (
                                                                <Button
                                                                    variant="text"
                                                                    endIcon={<EastIcon />}
                                                                    sx={{
                                                                        fontSize: "16px",
                                                                        fontWeight: 700,

                                                                        "& .MuiSvgIcon-root": {
                                                                            color: "#3538CD",
                                                                        },
                                                                    }}
                                                                    onClick={handleNextStory}
                                                                >
                                                                    Next Story
                                                                </Button>
                                                            )}
                                                        </Box>
                                                    </CardActions>
                                                </Card>
                                            )}
                                        </>
                                    </TabPanel>
                                )}
                            </TabContext>
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "310px",
                                }}
                            >
                                No story found
                            </Box>
                        )}
                    </>
                )}
            </Box>

            {/* Show Story in Modal */}
            <Modal
                open={openModal}
                hideActions={true}
                onClose={handleCloseModal}
                header={
                    <Typography component={"h1"} variant="h5" color={"#000"}>
                        Agent Stories
                    </Typography>
                }
                dividers={false}
                contentSx={{
                    "&.MuiDialogContent-root": {
                        padding: "0",
                    },
                }}
            >
                <Card sx={{ border: "unset", boxShadow: "unset", overflow: "unset" }}>
                    <CardHeader
                        avatar={
                            <Avatar
                                alt={currentStory.authorName}
                                src={contactAllImages[currentStory.authorImage]}
                                sx={{
                                    width: "60px",
                                    height: "60px",
                                    "& .MuiAvatar-img": {
                                        objectFit: "cover",
                                        objectPosition: "top center",
                                    },
                                }}
                            />
                        }
                        title={currentStory?.authorName}
                        subheader={currentStory?.authorRole}
                        sx={{
                            padding: "0 24px 0",
                        }}
                        titleTypographyProps={{
                            sx: {
                                color: "#26272B",
                                fontSize: "18px",
                                fontWeight: 600,
                                lineHeight: "20px" /* 125% */,
                            },
                        }}
                        subheaderTypographyProps={{
                            sx: {
                                color: "#312E81",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "20px" /* 166.667% */,
                            },
                        }}
                    />
                    <CardContent sx={{ padding: "16px 24px 16px" }}>
                        {currentStory?.title && (
                            <Typography component={"h1"} color={"#26272B"} fontSize={"20px"} fontWeight={700}>
                                {currentStory?.title}
                            </Typography>
                        )}
                        {currentStory.body && <RenderContent htmlString={currentStory.body}></RenderContent>}
                        {!currentStory.body && (
                            <Box>
                                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "80%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "80%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "80%" }} />
                            </Box>
                        )}

                        <Box display={"flex"} alignItems={"center"} marginTop={"1rem"}>
                            {!currentStory?.activity && (
                                <Button
                                    onClick={likeClick}
                                    startIcon={<FavoriteBorderIcon sx={{ color: "#FF0000" }} />}
                                    sx={{
                                        padding: 0,
                                        marginRight: "1rem",
                                        fontSize: "12px",
                                    }}
                                >
                                    LIKE
                                </Button>
                            )}
                            {currentStory?.activity && (
                                <Button
                                    onClick={removeLikeClick}
                                    startIcon={<FavoriteIcon sx={{ color: "#FF0000" }} />}
                                    sx={{
                                        padding: 0,
                                        marginRight: "1rem",
                                        fontSize: "12px",
                                    }}
                                >
                                    LIKED
                                </Button>
                            )}

                            {/* <Button
                                startIcon={<ShareIcon sx={{ color: "#20335B" }} />}
                                sx={{
                                    padding: "0",
                                    fontSize: "12px",
                                }}>
                                SHARE
                            </Button> */}
                        </Box>
                    </CardContent>
                    {currentStory?.mentionedSpeakers?.length > 0 && (
                        <CardContent sx={{ padding: "16px 24px", background: "#F5F8FF" }}>
                            <Typography component={"h2"} color={"#000"} fontSize={"18px"} fontWeight={700}>
                                Speakers mentioned in this post
                            </Typography>

                            <Grid container spacing={1} marginTop={"-0"}>
                                {currentStory?.mentionedSpeakers?.map((cItem) => (
                                    <Grid item key={cItem.id}>
                                        <Box
                                            onClick={() => {
                                                setOpenSpeakerScreen(true);
                                                setSpeakerSearchSelectedTeb("Biographies");
                                                setSelectedSpeaker({
                                                    Id: cItem.Speaker__r.Id,
                                                    name: cItem.Speaker__r?.Name,
                                                    img: cItem.Speaker__r?.Proposal_Portal_Speaker_Image__c,
                                                    gender: cItem.Speaker__r?.Gender__c,
                                                });
                                            }}
                                            sx={{
                                                borderRadius: "48px",
                                                border: "1px solid #E0EAFF",
                                                background: "#FFF",

                                                display: "flex",
                                                alignItems: "center",
                                                padding: "4px 10px 4px 4px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <Avatar
                                                src={cItem.Speaker__r?.Proposal_Portal_Speaker_Image__c}
                                                aria-label="Avatar"
                                                sx={{
                                                    width: "28px",
                                                    height: "28px",
                                                    marginRight: "0.5rem",
                                                }}
                                            ></Avatar>

                                            <Typography component={"span"} fontSize={"12px"} fontWeight={600}>
                                                {cItem.Speaker__r?.Name}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    )}
                </Card>
            </Modal>

            <Modal
                open={openSpeakerScreen}
                title="Speaker details"
                onClose={() => {
                    setOpenSpeakerScreen(false);
                    setSpeakerSearchSelectedTeb("");
                }}
                hideActions
                maxWidth="lg"
                removeTabIndex
                sx={{ padding: "0px" }}
                contentSx={{ overflowY: "hidden" }}
                PaperProps={{
                    sx: {
                        width: "100%", // added main container width
                    },
                }}
            >
                <Box
                    sx={{
                        height: "calc(100vh - 130px)",
                        // width: {
                        //     xs: "300px",
                        //     md: "590px",
                        //     lg: "auto",
                        // },
                    }}
                >
                    <Speaker
                        shared={false}
                        actionButtons={false}
                        userDetails={userDetails}
                        opportunityId={""}
                        opportunityName={""}
                        speakerId={selectedSpeaker.Id}
                        recordId={selectedSpeaker.Id}
                        speakerRecord={{
                            speakerName: selectedSpeaker.name,
                            speakerId: selectedSpeaker.Id,
                            speakerImageURL: selectedSpeaker?.img,
                        }}
                        removeActions={true}
                        hideFeesTab={false}
                        isBureau={false}
                        feeDetails={"Contact WSB"}
                        displayComments={false}
                        fromSpeakerSearch={true}
                        displayNotes={false}
                        speakerSearchRecord={selectedSpeaker}
                        speakerSearchSelectedTeb={speakerSearchSelectedTeb}
                        applyContainerWidth={true}
                    ></Speaker>
                </Box>
            </Modal>
        </Paper>
    );
}

export default AgentStoriesCard;
